export const KNOWLEDGE_BASE_SEARCH_MAX_LENGTH = 1000;

export type KnowledgeBaseSearchValidationError = 'empty' | 'tooLong';

export const validateKnowledgeBaseSearchQuery = (
  query: string,
): KnowledgeBaseSearchValidationError | null => {
  const normalizedQuery = query.trim();

  if (!normalizedQuery) return 'empty';
  if (normalizedQuery.length > KNOWLEDGE_BASE_SEARCH_MAX_LENGTH) return 'tooLong';

  return null;
};
